<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data PartGoodReceiptDetail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="purchaseOrderDetails" optionsLabel="qtyPo" optionsKey="id" label-cols-lg="12" label="Purchase Order Detail Id" id="input-" size="sm" :model.sync="model.purchaseOrderDetailId"   :selected="model.purchaseOrderDetail != null ? model.purchaseOrderDetail.qtyPo : ''" @input="getPurchaseOrderDetails" />
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part Code" id="input-" size="sm" :model.sync="model.partId" :isRequired="true" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" />
				<app-input-textbox id="fieldset-qty-outstanding-before" label-cols-lg="12" label="Qty Outstanding Before" label-for="input-qty-outstanding-before" size="sm" :model.sync="model.qtyOutstandingBefore" :isRequired="true" :state="validateState('qtyOutstandingBefore')" :errorMessage="getErrorMessage(errorMessage.qtyOutstandingBefore, 'qtyOutstandingBefore')"  />
				<app-input-textbox id="fieldset-qty-received" label-cols-lg="12" label="Qty Received" label-for="input-qty-received" size="sm" :model.sync="model.qtyReceived"  />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-qty-actual" label-cols-lg="12" label="Qty Actual" label-for="input-qty-actual" size="sm" :model.sync="model.qtyActual"  />
				<app-input-textbox id="fieldset-qty-outstanding-after" label-cols-lg="12" label="Qty Outstanding After" label-for="input-qty-outstanding-after" size="sm" :model.sync="model.qtyOutstandingAfter"  />
				<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark" label-for="input-remark" size="sm" :model.sync="model.remark"  />

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PartGoodReceiptDetail from '@/models/PartGoodReceipt/PartGoodReceiptDetail';
import PartGoodReceiptDetailFilter from '@/filters/PartGoodReceipt/PartGoodReceiptDetailFilter';

import PartGoodReceipt from '@/models/PartGoodReceipt/PartGoodReceipt';
import PartGoodReceiptFilter from '@/filters/PartGoodReceipt/PartGoodReceiptFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		partId: {required},
			qtyOutstandingBefore: {required},
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
				partId: { required : "Part Code is Required."},
				qtyOutstandingBefore: { required : "Qty Outstanding Before is Required."},
			},
			purchaseOrderDetails : [],
			parts : [],
			isBusy: false,
		}
	},
	methods : {
		getPartGoodReceiptDetail : async function(id) {
			this.isBusy = true;
			PartGoodReceiptDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getPurchaseOrderDetails : async function(input) {
			let filter = new PurchaseOrderDetailFilter();
			if (input != undefined) {
				filter.qtyPo = input;
			}
			PurchaseOrderDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseOrderDetails = result.data
				}
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getPurchaseOrderDetails();
		//this.getParts();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPartGoodReceiptDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getPurchaseOrderDetails();
				this.getParts();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPartGoodReceiptDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
